import { axiosFactory, errorHandler, currentPage } from "@/configs/axios";

const serviceTypeList = {
  api: () => {
    return axiosFactory()
      .auth.get("/services/company-vehicles/services-type/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const downloadServiceList = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams();

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      }
    }

    const queryString = queryParams.toString();
    const url = `exports/services/company-vehicles/${queryString ? "?" + queryString : ""}`;


    return axiosFactory({ type: 'blob' })
      .auth.get(url)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const serviceNameList = {
  api: () => {
    return axiosFactory()
      .auth.get("/services/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const serviceList = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams();

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      }
    }

    const queryString = queryParams.toString();
    const url = `services/company-vehicles/${queryString ? "?" + queryString : ""}`;


    return axiosFactory()
      .auth.get(
        url
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const serviceVisitList = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams();

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      }
    }

    const queryString = queryParams.toString();
    const url = `services/visits/${queryString ? "?" + queryString : ""}`;

    return axiosFactory()
      .auth.get(url)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export const downloadServiceVisitList = {
  api: (payload = {}) => {
    const queryParams = new URLSearchParams();

    if (payload) {
      for (const [key, value] of Object.entries(payload)) {
        if (value !== null && value !== undefined && value !== "") {
          queryParams.append(key, value);
        }
      }
    }

    const queryString = queryParams.toString();
    const url = `exports/services/visits/${queryString ? "?" + queryString : ""}`;

    return axiosFactory({ type: 'blob' })
      .auth.get(url)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const getAService = {
  api: (payload) => {
    return axiosFactory()
      .auth.get("/services/company-vehicles/" + payload + "/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const getAServiceVisit = {
  api: (payload) => {
    return axiosFactory()
      .auth.get("/services/visits/" + payload + "/")
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const addService = {
  api: (payload) => {
    return axiosFactory()
      .auth.post("/services/company-vehicles/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const addServiceVisit = {
  api: (payload) => {
    return axiosFactory()
      .auth.post("/services/visits/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const editService = {
  api: (payload) => {
    return axiosFactory()
      .auth.put("/services/company-vehicles/" + payload.id + "/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const editServiceVisit = {
  api: (payload) => {
    return axiosFactory()
      .auth.put("/services/visits/" + payload.id + "/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};
const removeService = {
  api: (payload) => {
    return axiosFactory()
      .auth.delete("/services/company-vehicles/" + payload + "/")
      .then((res) => {
        return true;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export {
  serviceTypeList,
  serviceNameList,
  getAService,
  getAServiceVisit,
  addService,
  addServiceVisit,
  editService,
  editServiceVisit,
  serviceList,
  serviceVisitList,
  removeService,
};
